import { render, staticRenderFns } from "./Result.vue?vue&type=template&id=9f317bf4&scoped=true&"
import script from "./Result.vue?vue&type=script&lang=js&"
export * from "./Result.vue?vue&type=script&lang=js&"
import style0 from "./Result.vue?vue&type=style&index=0&id=9f317bf4&prod&lang=css&"
import style1 from "./Result.vue?vue&type=style&index=1&id=9f317bf4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f317bf4",
  null
  
)

export default component.exports